import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FiBell } from "react-icons/fi";
import { FiTrash } from "react-icons/fi";

import { useSocket } from "../contexts/SocketContext";
import { ShowApiErrorToast } from "../Components/ShowAPIErrors";
import apis from "../services";
import { toast } from "react-toastify";

const headerConfig = {
  "/home": {
    title: "Lookna",
    subtitle: (
      <>
        FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
      </>
    ),
  },
  "/login": {
    title: "Lookna",
    subtitle: (
      <>
        FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
      </>
    ),
  },
  "/signup": {
    title: "Lookna",
    subtitle: (
      <>
        FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
      </>
    ),
  },
  "/forgot-password": {
    title: "Lookna",
    subtitle: (
      <>
        FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
      </>
    ),
  },
  "/verification": {
    title: "Lookna",
    subtitle: (
      <>
        FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
      </>
    ),
  },
  "/change-password": {
    title: "Lookna",
    subtitle: (
      <>
        FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
      </>
    ),
  },
  "/CEX": {
    title: "Lookna",
    subtitle: (
      <>
        FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
      </>
    ),
    description:
      "Discover a range of investment options tailored to your needs, from automated solutions to customizable strategies",
  },
  "/Profile": {
    title: "My Profile",
    subtitle: (
      <>
        FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
      </>
    ),
  },
  "/Lookna-wallet": {
    title: "Lookna",
    subtitle: (
      <>
        FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
      </>
    ),
    description:
      "Send, receive, and manage your crypto seamlessly with a secure, smart, and easy-to-use digital wallet.",
  },
  "/history": {
    title: "Lookna",
    subtitle: (
      <>
        FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
      </>
    ),
    description:
      "Explore diverse transactions—from automated actions to personalized transfers—all securely recorded in one Wallet history",
  },
  "/check-scam": {
    title: "Lookna",
    subtitle: (
      <>
        FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
      </>
    ),
  },
  "/DEX": {
    title: "Lookna",
    subtitle: (
      <>
        FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
      </>
    ),
  },
  "/PS-detail": {
    title: "Lookna",
    subtitle: (
      <>
        FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
      </>
    ),
  },
  "/detail-view": {
    title: "Lookna",
    subtitle: (
      <>
        FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
      </>
    ),
  },
  "/private-sale": {
    title: "Lookna",
    subtitle: (
      <>
        FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
      </>
    ),
  },
  "/watch-list": {
    title: "My Watchlist",
    subtitle: (
      <>
        FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
      </>
    ),
  },
  "/Terms-and-Condition": {
    title: "Terms and Conditions",
    subtitle: (
      <>
        FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
      </>
    ),
  },
  "/Privacy-Policy": {
    title: "Privacy Policy",
    subtitle: (
      <>
        FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
      </>
    ),
  },
  "/Education-Section": {
    // titleNew : "Educational Section" ,
    title: "Educational Section",
    subtitle: (
      <>
        FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
      </>
    ),
    description:
      "Discover a range of investment options tailored to your needs, from automated solutions to customizable strategies",
  },
};

const defaultHeader = {
  title: "Lookna",
  subtitle: (
    <>
      FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
    </>
  ),
};

const notifications = [
  { id: 1, message: "Welcome to Lookna!" },
  { id: 2, message: "Your profile was updated successfully." },
];

const DynamicHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;

  const [notifications, setNotifications] = useState([]);
  const [toggler, setToggler] = useState(false);

  const { socket } = useSocket();

  const { titleNew, title, subtitle, description } =
    headerConfig[path] || defaultHeader;

  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const userId = localStorage.getItem("userId");

  const fetchNotifications = async () => {
    try {
      const res = await apis.getNotifications();
      setNotifications(res.notifications);
    } catch (error) {
      ShowApiErrorToast(error);
    }
  };
  console.log(notifications, "Notifications Data");

  useEffect(() => {
    fetchNotifications();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      // setToggler(!toggler);
      socket.emit("notifications-req", userId);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    socket.on("notification-req", (message) => {
      setNotifications((prev) => [...prev, message]);
      console.log(message, "---------");
    });

    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const readNotifications = async () => {
    try {
      const response = await apis.handleReadNotifications();
      setNotifications(response.notifications);
      setOpen((v) => !v);
    } catch (error) {
      ShowApiErrorToast(error);
    }
  };

  const clearNotification = async () => {
    try {
      const response = await apis.handleClearNotifications();
      console.log(response);
      setNotifications([]);
      toast.success("Notifications Cleared!");
    } catch (error) {
      ShowApiErrorToast(error);
    }
  };

  return (
    <div className="header-container">
      <div className="header-content">
        <div className="header-main">
          <h2 className="header-title">{titleNew}</h2>
          <h2 className="header-title">{title}</h2>
          <div className="header-subtitle">{subtitle}</div>
          {description && <p className="header-description">{description}</p>}
        </div>
        <div className="header-notification">
          <button
            className="notification-btn"
            onClick={readNotifications}
            aria-label="Notifications"
          >
            <FiBell size={28} color="#b68cff" />
            {notifications.filter((item) => item.hasRead === false).length >
              0 && <span className="notification-dot" />}
          </button>
          <div
            className={`notification-dropdown${open ? " open" : ""}`}
            ref={dropdownRef}
            style={{ display: open ? "block" : "block" }}
          >
            {notifications.length === 0 ? (
              <div className="notification-empty">No notifications</div>
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingInline: "10px",
                    borderBottom: "1px solid grey",
                  }}
                >
                  <p>Notifications</p>
                  <FiTrash
                    onClick={clearNotification}
                    size={20}
                    color="#b68cff"
                    style={{ cursor: "pointer" }}
                  />
                </div>
                {notifications.map((n) => (
                  <div className="notification-item" key={n._id}>
                    {n.message}
                  </div>
                ))}
                <button
                  className="see-all-btn"
                  onClick={() => {
                    setOpen(false);
                    navigate("/Notification");
                  }}
                >
                  See all
                </button>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="details-borders"></div>
      <style>{`

     .header-container {
  width: 100%;
  background: transparent;
  padding: 32px 0 0 0;
  box-sizing: border-box;
}

.header-content {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  position: relative;
}

.header-main {
  flex: 1 1 0%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-right: 60px;
}

.header-title {
  color: #b68cff;
  font-size: clamp(1.2rem, 6vw, 2.4rem);
  font-weight: bold;
  text-align: center;
  margin: 0 0 18px 0;
  letter-spacing: 1px;
}

.header-subtitle {
  color: #fff;
  text-align: center;
  font-size: clamp(0.96rem, 3vw, 1.3rem);
  font-weight: 700;
  margin-bottom: 24px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.color-sp {
  color: #b68cff;
  font-weight: bold;
  margin: 0 3px;
}

.header-description {
  color: #c7c1dc;
  font-size: clamp(0.85rem, 2vw, 1.02rem);
  margin-top: 0;
  margin-bottom: 30px;
  text-align: center;
  max-width: 95vw;
  width: 100%;
  box-sizing: border-box;
}

.header-notification {
  position: absolute;
  top: 0;
  right: 1vw;
  display: flex;
  align-items: flex-start;
}

.notification-btn {
  background: none;
  border: none;
  cursor: pointer;
  position: relative;
  padding: 0;
  display: flex;
  align-items: center;
}

.notification-dot {
  position: absolute;
  top: 6px;
  right: 4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #b68cff;
}

.notification-dropdown {
  position: absolute;
  top: 50px;
  right: 0;
  background: #191725;
  color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.2);
  min-width: 260px;
  z-index: 999;
  padding: 12px 0;
  max-height: 320px;
  overflow-y: auto;
    opacity: 0;
  transform: translateY(-18px) scale(0.98);
  pointer-events: none;
  transition: opacity 0.25s cubic-bezier(.4,0,.2,1), transform 0.25s cubic-bezier(.4,0,.2,1);
}
  .notification-dropdown.open {
  opacity: 1;
  transform: translateY(0) scale(1);
  pointer-events: auto;
}

.notification-item {
  padding: 12px 20px;
  border-bottom: 1px solid #282338;
  font-size: 15px;
  white-space: normal;
}

.notification-item:last-child {
  border-bottom: none;
}

.notification-empty {
  padding: 16px;
  text-align: center;
  color: #bbb;
}

.see-all-btn {
  width: 100%;
  background: none;
  border: none;
  color: #b68cff;
  font-weight: 700;
  padding: 13px 0 9px 0;
  cursor: pointer;
  border-radius: 0 0 10px 10px;
  transition: background 0.15s;
}

.see-all-btn:hover {
  background: #26223b;
}

.details-borders {
  border-top: 2px solid #282338;
  margin-top: 16px;
}

@media (max-width: 900px) {
  .header-title { font-size: clamp(1.1rem, 5vw, 1.8rem); }
  .header-main { padding-right: 24px; }
  .header-subtitle { font-size: 1.05rem; margin-bottom: 18px;}
  .header-notification { right: 3vw; }
}

@media (max-width: 600px) {
  .header-main { padding-right: 0; }
  .header-title { font-size: clamp(1rem, 4vw, 1.22rem); }
  .header-subtitle { font-size: 0.96rem; margin-bottom: 10px;}
  .header-description { font-size: 0.9rem; margin-bottom: 18px; }
  .header-notification {
    right: 4vw;
    top: 20px;
  }
  .notification-dropdown {
    min-width: 85vw;
  }
}

@media (max-width: 500px) {
  .header-notification {
    right: 1vw;
    top: -20px;
    transform: scale(0.95);
  }
  .header-description {
    font-size: 0.86rem;
    padding: 0 6px;
  }
}

      `}</style>
    </div>
  );
};

export default DynamicHeader;
